import axios from "axios"
export default {
  state: {
    allPages: null,
    isLoadPages: false

  },
  mutations: {
    setAllPages(state, payload) {
      state.allPages = payload;
    },
    setLoadPages(state, payload) {
      state.isLoadPages = payload;
    },

  },
  actions: {
    setAllPages({
      commit
    }, payload) {
      commit('setAllPages', payload)
    },
    setLoadPages({
      commit
    }, payload) {
      commit('setLoadPages', payload)
    },

  },
  getters: {

    getAllPages(state) {
      return state.allPages;
    },
    getLoadPages(state) {
      return state.isLoadPages;
    },
    loadPagesData(state){
      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_pages",
      })
        .catch(function (error) {
        if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
         if(DEBUG) console.log("response dataPAGES =", response.data.pages);
        state.allPages = response.data.pages;
        state.isLoadPages = true;
        return state.allPages;
        // state.loadAllData.getSitePages = true;
        });
    }

  }
}
